module.exports = __webpack_public_path__ + "img/intro_uk.5a5bc946.svg";